import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { createArtifactApi, storeArtifactApi } from './artifactSlice';
import ArtifactForm from './ArtifactForm';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { initialValues, pictureAttributeNames } from './initialValue';


function ArtifactCreate() {
    const [resetCount, setResetCount] = useState(0);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (values) => {
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        dispatch(storeArtifactApi({ navigate, values }));
    };

    return (
        <ArtifactForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={pictureAttributeNames}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default ArtifactCreate;
